import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

import { BlockPreviewPanelComponent } from './block-preview-panel.component';
import { BlockPreviewToggleComponent } from './block-preview-toggle.component';
import { BlockPreviewComponent } from './block-preview.component';

/** The block preview (#263): the panel and its toggle, for the content editors (ContentModule) and the Suburbs tool. */
@NgModule({
  declarations: [BlockPreviewComponent, BlockPreviewPanelComponent, BlockPreviewToggleComponent],
  imports: [CommonModule, ButtonModule, TooltipModule],
  exports: [BlockPreviewComponent, BlockPreviewToggleComponent],
})
export class BlockPreviewModule {}
